import React, { useEffect, useState, useRef } from "react";
import "./Header.scss";
import { HeaderLogo, HeaderLogoNew } from "assets/images/index";
import {
  Link,
  NavLink,
  useMatch,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { newbadgeimage } from "assets/images/index";
import {
  Combo,
  Foundation,
  Location,
  Menuclaseimg,
  Mobilemenu,
  Modular,
  Optional,
  Penimg,
} from "assets/icons/index";
import useCookie from "hooks/useCookie";
import Avatar from "./Avatar";
import TopBar from "./Topbar";
import CourseMenu from "./Menu/CourseMenu";
import ExamMenu from "./Menu/ExamMenu";
import CenterMenu from "./Menu/CenterMenu";
import FreeResourcesMenu from "./Menu/FreeResourcesMenu";
import MobileCourseMenu from "./mobile-menu/MobileCourse";
import MobileCenterMenu from "./mobile-menu/MobileCenter";
import MobileExamMenu from "./mobile-menu/MobileExam";
import MobileFreeResource from "./mobile-menu/MobileFreeResource";
import CircularMarquee from "../../../pages/home/Section/CircularMarquee";
const Header = () => {
  const { cookies } = useCookie();
  const [scroll, setScroll] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const excludeDetailPage = useMatch("/course-detail/:name/:id");
  const excludeListingPage = useMatch("/course-listing");

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
    document.body.classList.toggle("mobile_open", mobileMenu);
  }, [mobileMenu]);

  // remove the config from local if user change the journey
  useEffect(() => {
    if (!excludeDetailPage && !excludeListingPage) {
      sessionStorage.removeItem("config");
    }
  }, [excludeDetailPage, excludeListingPage]);
  const navigate = useNavigate();

  const navigationforTopperCopies = () => {
    setMobileMenu(false);
    navigate("/dashboard/book-mentor-appointment"); // Use navigate to go back to the specified route
  };

  const marqueeRef = useRef(null);

  const marqueeLinks = [
    {
      title: "PSIR Course - Admission open",
      href: "https://www.shubhraranjan.com/course-listing/course/Optional%20Courses/2/Shubhra%20Ranjan%20Course/23",
    },
    {
      title: "PSIR Mission 1250 (PSIR GS2 Ethics Essay) - Admission open",
      href: "https://www.shubhraranjan.com/course-detail/PSIR%20Mission%201250%20Marks%20(PSIR%20GS2%20Ethics%20Essay)%20UPSC%20Classroom%20Course%20/04eb143e-d02c-450d-8a8c-fce7434acc84",
    },
    {
      title: "Click here for Humanities Courses",
      href: "#humanity_courses",
    },
    // {
    //   title: "History Optional - Admissions Open",
    //   href: "https://www.shubhraranjan.com/history-optional-classroom-course",
    // },
    // {
    //   title: "Sociology Mission 1250 (PSIR GS2 Ethics Essay) - Admission open",
    //   href: "https://www.shubhraranjan.com/course-detail/Sociology%20Mission%201250%20Marks%20(Sociology%20GS2%20Ethics%20Essay)%20UPSC%20Classroom%20Course/3b5e55d8-897c-415e-807b-d460524c4f25",
    // },
    {
      title: "Sociology Optional Foundation Course",
      href: "https://instituteforhumanities.com/courses/83",
    },
  ];

  const htmlContent = marqueeLinks
    .map(
      ({ title, href }) =>
        `<a class="scrolling-text1" href="${href}">&#10148;&nbsp;${title}</a>`,
    )
    .join("");

  const handleMouseOver = () => {
    if (marqueeRef.current) marqueeRef.current.stop();
  };

  const handleMouseOut = () => {
    if (marqueeRef.current) marqueeRef.current.start();
  };

  const pathName = window.location.pathname;
  let showMarquee = "Y";
  if (pathName != "/") {
    showMarquee = "N";
  }

  const location = useLocation();
  const [homePage, sethomePage] = useState(false);

  React.useEffect(() => {
    sethomePage(location.pathname === "/");
  }, [location.pathname]);

  return (
    <>
      {/* TopBar */}
      <TopBar />
      <div className={`header_wrapper ${scroll ? "scrollheader" : ""}`}>
        <header
          className="header"
          style={{ padding: homePage ? "20px 0 0 5px" : "20px 0px" }}
        >
          <div className="container">
            <div
              className="mobile_button"
              onClick={() => {
                setMobileMenu(!mobileMenu);
              }}
            >
              <img src={Mobilemenu} alt="" loading="lazy" />
            </div>
            <div className="logo">
              <Link to="/">
                <img src={HeaderLogoNew} alt="Shubra ranjan" loading="lazy" />
              </Link>
            </div>
            <nav className="navigation">
              <ul>
                {/* Menu-1 */}
                <CourseMenu />
                {/* Menu-2 */}
                <ExamMenu />
                {/* <li>
                  <NavLink
                    to="/freeresources"
                    className="nav_link"
                  >
                    Free Resources
                  </NavLink>
                </li> */}

                {/* Menu-3 */}

                {/* <li>
                  <NavLink to="http://freeresources.shubhraviraj.in/" className="nav_link" target="_blank" rel="noopener noreferrer">
                    Free Resources
                  </NavLink>
                </li> */}

                {/* Menu-4 */}

                <li>
                  <a
                    href="https://instituteforhumanities.com/reader-column/subject-wise"
                    className="nav_link"
                    rel="noopener noreferrer"
                  >
                    Blogs & Current Affairs
                  </a>
                </li>

                <FreeResourcesMenu />

                <CenterMenu />

                {/* Menu-5 */}
                <li style={{ position: "relative" }} className="topperli">
                  <NavLink to="/toppers-copies" className="new_badgenav_link">
                    <span
                      style={{
                        fontWeight: "500",
                        position: "relative",
                        color: "black",
                      }}
                    >
                      Topper's&nbsp;Copies
                    </span>
                    <img
                      src={newbadgeimage}
                      alt="New Badge"
                      className="new_badge"
                    />
                  </NavLink>
                </li>
              </ul>
              <div className="button_wrap header_button">
                {/* if user is logged in */}
                {cookies && <Avatar type="home" />}

                {/* if user is not logged in  */}
                {!cookies && (
                  <Link to="/login" className="button">
                    Sign In / Sign Up
                  </Link>
                )}
              </div>
            </nav>
            {/* change  Language  */}
            {/* <div className="language_menu">
              <img src={Globimg} alt="glob" loading="lazy"/>
              <select
                value={language}
                onChange={({ target }) => setLanguage(target.value)}
              >
                <option value="EN">EN</option>
                <option value="HN">HN</option>
              </select>
            </div> */}

            {/*//////////////////// Mobile Menu //////////////////*/}

            <div className="mobile_menu">
              <div className="menu_title">
                <h3>Menu</h3>
                <img
                  src={Menuclaseimg}
                  alt=""
                  onClick={() => setMobileMenu(false)}
                />
              </div>

              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Recommended Courses</Accordion.Header>
                  <Accordion.Body>
                    <MobileCourseMenu menuClose={() => setMobileMenu(false)} />
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>Exam</Accordion.Header>
                  <Accordion.Body>
                    <MobileExamMenu menuClose={() => setMobileMenu(false)} />
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>Free Resources</Accordion.Header>
                  <Accordion.Body>
                    <MobileFreeResource
                      menuClose={() => setMobileMenu(false)}
                    />
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>Our Centers</Accordion.Header>
                  <Accordion.Body>
                    <MobileCenterMenu menuClose={() => setMobileMenu(false)} />
                  </Accordion.Body>
                </Accordion.Item>

                <ul className="mobile_menu_title">
                  {/* <li>
                    <Link to="http://freeresources.shubhraviraj.in/">Free Resources</Link>
                  </li> */}
                  <li>
                    <Link to="/blog-post" onClick={() => setMobileMenu(false)}>
                      Blogs & Current Affairs
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/dashboard/toppers-copies" onClick={() => setMobileMenu(false)}>
                      <span style={{ color: "#dcba08", fontWeight: "600" }}>Topper's&nbsp;Copies </span>
                    </Link>
                  </li> */}
                </ul>
                <ul className="mobile_topper_title">
                  <li className="topperlimobile">
                    <Link
                      to="/toppers-copies"
                      className="new_badgenav_link"
                      onClick={() => setMobileMenu(false)}
                    >
                      <span
                        style={{
                          fontWeight: "500",
                          position: "relative",
                          color: "black",
                        }}
                      >
                        Topper's&nbsp;Copies
                      </span>
                      <img
                        src={newbadgeimage}
                        alt="New Badge"
                        className="new_badge"
                      />
                    </Link>
                  </li>
                </ul>
              </Accordion>

              {/* <div className="button_wrap fill">
                {cookies ? (
                  <>
                    <Avatar type="home" />
                  </>
                ) : (
                  <Link
                    to="/signup"
                    className="button"
                    onClick={() => setMobileMenu(false)}
                  >
                    Sign In / Sign Up
                  </Link>
                )}
              </div> */}
            </div>
          </div>

          {showMarquee == "Y" && (
            <div
              className="col-md-12"
              style={{
                padding: "10px",
                textAlign: "center",
                background: "#fcef09d9",
              }}
            >
              <div>
                <CircularMarquee
                  html={htmlContent}
                  speed={25}
                  pauseOnHover={true}
                />
              </div>
            </div>
          )}
        </header>
        <div
          className="mobile_overlay"
          onClick={() => setMobileMenu(false)}
        ></div>
      </div>
    </>
  );
};

export default Header;
